import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionAppOverviewForm } from '../forms/SubstitutionAppOverviewForm';

type SubstitutionAppOverviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SubstitutionAppOverviewModal = ({ isOpen, onClose }: SubstitutionAppOverviewModalProps) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={isLoading}
      title={t('substitutions.app.editOverview')}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <SubstitutionAppOverviewForm onLoad={setIsLoading} onClose={onClose} />
    </Modal>
  );
};
